import { Box } from '@chakra-ui/react';
import { ReactElement, memo } from 'react';
import { NewWidget } from 'widgets/Widget.types';

import { UploadMenu } from '../ImageUploadMenu/UploadMenu';

export interface PhotoWidgetMenuProps {
  isMenuActive: boolean;
  onItemClick: (widget: NewWidget | NewWidget[]) => void;
}

export const PhotoWidgetMenuCategory = memo(
  ({ isMenuActive, onItemClick }: PhotoWidgetMenuProps): ReactElement | null => {
    return (
      <Box display={isMenuActive ? 'block' : 'none'} h='full'>
        <UploadMenu onAddUploadImage={onItemClick} />
      </Box>
    );
  },
);
PhotoWidgetMenuCategory.displayName = 'PhotoWidgetMenuCategory';
